import { useState } from "react";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";
import Common_Btn from "../../../common/common-btn/Common_Btn";
import White_Btn from "../../../common/common-btn/white-btn/White_Btn";
import Form_Header from "../../../common/form-header/Form_Header";
import "./Create_Account_Step3.css";

const Create_Account_Step3 = ({ setStep }) => {
 const numbers = Array.from({ length: 500 }, (_, i) => i + 1);

  // ✅ Default weight
  const defaultWeight = 40;
  const [value, setValue] = useState(defaultWeight);

  return (
    <section className="step1_wrapper step3_wrapper">
      <Form_Header step={3} totalSteps={6} />

      <div className="weight_selection_div">
        <h2 className="select_title">Select Your Weight</h2>

        <div className="weight_wrapper">
          {/* Center Value Display */}
          <h1 className="weight_value">
            {value} <span>kg</span>
          </h1>

          <div className="scale_container">
            <div className="center_line" />

            <Swiper
              slidesPerView={10}
              centeredSlides={true}
              spaceBetween={10}
              grabCursor={true}
              initialSlide={defaultWeight - 1}
              onSlideChange={(swiper) => {
                setValue(numbers[swiper.activeIndex]);
              }}
              className="weight_swiper"
            >
              {numbers.map((num) => (
                <SwiperSlide key={num}>
                  {({ isActive }) => (
                    <div className={`scale_item ${isActive ? "active" : ""}`}>
                      {num}
                    </div>
                  )}
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>

        <div className="form_btn_holder">
          <White_Btn btnText="Back" onClick={() => setStep(2)} />
          <Common_Btn btnText="Next" onClick={() => setStep(4)} />
        </div>
      </div>
    </section>
  );
};

export default Create_Account_Step3;
